var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJapan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.41162,
    width: 20,
    height: 14.2857,
    rx: 2.08914,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 20,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.41162,
    width: 20,
    height: 14.2857,
    rx: 2.08914,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3480)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.41162,
    width: 20,
    height: 14.2857,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.9342H7.61905V18.6485H12.381V12.9342H20V8.17229H12.381V2.45801H7.61905V8.17229H0V12.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.916016,
    y: 2.04199,
    width: 27.6191,
    height: 1.90476,
    transform: "rotate(34 -0.916016 2.04199)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.97998,
    y: 17.4861,
    width: 27.6191,
    height: 1.90476,
    transform: "rotate(-34 -1.97998 17.4861)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3345 7.9357L22.3812 1.98413",
    stroke: "#DB1F35",
    strokeWidth: 0.696379,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2964 13.1946L22.4063 18.6609",
    stroke: "#DB1F35",
    strokeWidth: 0.696379,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71858 7.91881L-2.74072 2.21777",
    stroke: "#DB1F35",
    strokeWidth: 0.696379,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63608 13.1291L-2.74072 19.3474",
    stroke: "#DB1F35",
    strokeWidth: 0.696379,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.983H8.57143V17.6973H11.4286V11.983H20V9.12591H11.4286V3.41162H8.57143V9.12591H0V11.983Z",
    fill: "#E6273E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapan);
export default __webpack_public_path__ + "static/media/Japan.c2845a7014162f6da3b0cfbde6e9bee0.svg";
export { ForwardRef as ReactComponent };